<template>
    <div class="page-block__item" v-if="canSeePrivateWhois">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('domain.whois.private') }}
                    </span>
                </div>
                <!--
                -->
                <div class="layout__item u-2/3-desk" v-if="whoisData">
                    <private-whois-status :label="trans('domain.whois.private')" :status="privateWhoisStatus" />

                    <p v-if="canSupportPrivateWhois" class="alert alert--warning u-margin-top-narrow">
                        {{ trans('domain.whois.private-support') }}
                    </p>
                </div>
                <div v-else class="layout__item u-2/3-desk">
                    <div class="loader loader--small">
                        <span class="loader__ring loader__ring--small"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav | u-align-self-start" v-if="canEditPrivateWhois">
            <button
                v-if="whoisData && !whoisData.is_private"
                @click="showEnablePrivateWhoisModal"
                type="button"
                class="btn btn--ghost btn--ghost-full-width"
            >
                {{ trans('domain.whois.private-enable') }}
            </button>

            <button
                v-if="whoisData && whoisData.is_private"
                @click="showDisablePrivateWhoisModal()"
                type="button"
                class="btn btn--ghost btn--ghost-full-width"
            >
                {{ trans('domain.whois.private-disable') }}
            </button>
        </div>

        <enable-private-whois-modal
            v-if="enablePrivateWhoisModalVisible"
            @close="closeEnablePrivateWhoisModal"
            :domain="domain"
        />

        <disable-private-whois-modal
            v-if="disablePrivateWhoisModalVisible"
            @close="closeDisablePrivateWhoisModal"
            :domain="domain"
        />
    </div>
</template>

<script>
import EnablePrivateWhoisModal from './DomainPrivateWhoisEnableModal.vue';
import DisablePrivateWhoisModal from './DomainPrivateWhoisDisableModal.vue';
import PrivateWhoisStatus from './DomainPrivateWhoisStatus.vue';
import { productMixin } from 'relapp-register';
import parseDomain from 'parse-domain';

export default {
    mixins: [productMixin],
    components: {
        EnablePrivateWhoisModal,
        DisablePrivateWhoisModal,
        PrivateWhoisStatus
    },
    props: {
        whoisData: {
            type: Object,
            default: null
        },
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @returns {object}
     */
    data() {
        return {
            enablePrivateWhoisModalVisible: false,
            disablePrivateWhoisModalVisible: false
        };
    },
    computed: {
        /**
         * Returns a property used by productMixin to get the product data.
         *
         * @returns {{domain: string, name: string, type: string}}
         */
        productPlan() {
            return {
                domain: this.domain,
                name: '.' + parseDomain(this.domain).tld,
                type: 'extension'
            };
        },
        /**
         * Returns true if the private whois setting can be seen.
         *
         * @returns {boolean}
         */
        canSeePrivateWhois() {
            let product = this.product;

            if (!product) {
                return false;
            }

            let setting = product.descriptors.small['product-spec.domain.allow_whois_private'];

            return ['yes', 'support'].includes(setting);
        },
        /**
         * Returns true if the private whois setting can be edited.
         *
         * @returns {boolean}
         */
        canEditPrivateWhois() {
            let product = this.product;

            if (!product) {
                return false;
            }

            return product.descriptors.small['product-spec.domain.allow_whois_private'] === 'yes';
        },
        /**
         * Returns true if support must edit the private whois.
         *
         * @returns {boolean} yes/support/no
         */
        canSupportPrivateWhois() {
            let product = this.product;

            if (!product) {
                return false;
            }

            return product.descriptors.small['product-spec.domain.allow_whois_private'] === 'support';
        },
        /**
         * Private whois status label.
         *
         * @return {string}
         */
        privateWhoisStatus() {
            if (this.whoisData.is_private) {
                return 'active';
            } else {
                return 'unprotected';
            }
        }
    },
    methods: {
        /**
         * Show enable private whois modal.
         */
        showEnablePrivateWhoisModal() {
            this.enablePrivateWhoisModalVisible = true;
        },
        /**
         * Close enable private whois modal.
         */
        closeEnablePrivateWhoisModal() {
            this.enablePrivateWhoisModalVisible = false;
        },
        /**
         * Show disable private whois modal.
         */
        showDisablePrivateWhoisModal() {
            this.disablePrivateWhoisModalVisible = true;
        },
        /**
         * Close disable private whois modal.
         */
        closeDisablePrivateWhoisModal() {
            this.disablePrivateWhoisModalVisible = false;
        }
    }
};
</script>
